import { SelectionModel } from '@angular/cdk/collections'
import { FlatTreeControl, NestedTreeControl } from '@angular/cdk/tree'
import {
  Component,
  Injectable,
  OnInit,
  Input,
  EventEmitter,
  Output
} from '@angular/core'
import {
  MatTreeFlatDataSource,
  MatTreeFlattener,
  MatTreeNestedDataSource
} from '@angular/material/tree'
import { BehaviorSubject } from 'rxjs'
import { MatDialog } from '@angular/material'
import { BarcodeScannerComponent } from 'src/app/modules/sales/out-for-delivery/barcode-scanner/barcode-scanner.component'

/**
 * @title Tree with checkboxes
 */
@Component({
  selector: 'app-mat-tree',
  templateUrl: 'mat-tree.component.html',
  styleUrls: ['mat-tree.component.css']
})
export class MatTreeComponent {
  @Input() treeData$
  @Input() emittedData$
  @Input() picked
  openScanner
  @Output() emittedData = new EventEmitter<any>()
  treeControl = new NestedTreeControl<any>(node => node.children)
  dataSource = new MatTreeNestedDataSource<any>()

  constructor(public dialog: MatDialog) {}
  ngOnInit() {
    this.treeData$.subscribe(treeData => {
      this.dataSource.data = treeData
      Object.keys(this.dataSource.data).forEach(x => {
        this.setParent(this.dataSource.data[x], null)
      })
    })
    this.emittedData$.subscribe(() => {
      let result = []
      this.dataSource.data.forEach(node => {
        if (node.type === 'simple' && node.selected) {
          result.push({
            _id: node.id,
            type: node.type,
            pickupBarcode: node.barcode
          })
        }
        if (node.type === 'package') {
          let subItems = this.treeControl
            .getDescendants(node)
            .filter(subItem => subItem.selected)
            .map(elem => {
              return {
                id: elem.id.toString(),
                pickupBarcode: elem.barcode
              }
            })
          let nonSubItems = this.treeControl
            .getDescendants(node)
            .filter(subItem => !subItem.selected)
            .map(elem => elem.id.toString())
          if (subItems.length) {
            result.push({
              _id: node.id,
              type: node.type,
              pickupBarcode: node.barcode,
              selectedProducts: subItems,
              nonSelectedProductIds: nonSubItems
            })
          }
        }
      })
      this.emittedData.emit(result)
    })
  }

  hasChild = (_: number, node: any) =>
    !!node.children && node.children.length > 0
  setParent(data, parent) {
    data.parent = parent
    if (data.children) {
      data.children.forEach(x => {
        this.setParent(x, data)
      })
    }
  }

  checkAllParents(node) {
    if (node.parent) {
      const descendants = this.treeControl.getDescendants(node.parent)
      node.parent.selected = descendants.every(child => child.selected)
      node.parent.indeterminate = descendants.some(child => child.selected)
      this.checkAllParents(node.parent)
    }
  }
  todoItemSelectionToggle(checked, node) {
    node.selected = checked
    if (node.children) {
      node.children.forEach(x => {
        this.todoItemSelectionToggle(checked, x)
      })
    }
    this.checkAllParents(node)
  }

  openScannerEvent(node, subnode = undefined) {
    this.openScanner = false
    this.openScanner = true
    let dialogRef = this.dialog.open(BarcodeScannerComponent, {
      width: '70%'
    })
    dialogRef.componentInstance.result.subscribe(barcode => {
      this.dialog.closeAll()
      if (subnode) {
        subnode.barcode = barcode
        return
      }
      node.barcode = barcode
      return
    })
  }

  barcodeChanged(barcode, node, subnode = undefined) {
    if (subnode) {
      subnode.barcode = barcode
      return
    }
    node.barcode = barcode
    return
  }
}

/**  Copyright 2019 Google LLC. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license */
